import { useStore } from 'zustand';
import { downloadFileFactory } from './factory';
import type { DownloadFileState } from './interfaces';

export const downloadFileStore = downloadFileFactory();

export const useDownloadFile = <T>(s: (state: DownloadFileState) => T) =>
  useStore(downloadFileStore, s);
